<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<h1 class="plm_hd"><a href="#/Text/DEUT_contents">Chief abbreviations</a></h1>
<p class="abb_fo"><em class="italic">NBD – The New Bible Dictionary</em> (IVP, 2nd edition 1982).</p>
<p class="abb_fo"><span class="smallcaps">neb</span> – <em class="italic">The New English Bible</em> (NT 1961, 2nd edition 1970; OT 1970).</p>
<p class="abb_fo"><span class="smallcaps">niv</span> – <em class="italic">The New International Version</em> of the Bible (Hodder and Stoughton; 1979, 1984, 2011).</p>
<p class="abb_fo"><span class="smallcaps">nrsv</span> – <em class="italic">The New Revised Standard Version of the Bible</em> (NT 1946, 2nd edition 1971; OT 1952, 1989, 1995).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DEUT_abbrev.vue?27c0af26